"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const LabeledMultiValueGroupWidget_1 = tslib_1.__importDefault(require("../widget/LabeledMultiValueGroupWidget"));
class TypedWCAGCheckboxGroup extends LabeledMultiValueGroupWidget_1.default {
    constructor(args) {
        super({
            ...args,
            groupChildElements: []
        });
    }
    getValue() {
        if (this.headerCheckbox) {
            const value = this.headerCheckbox.getValue();
            if (value) {
                return [value, ...this.value];
            }
        }
        return this.value;
    }
    setValue(newValue, fireEvents = false) {
        if (this.headerCheckbox) {
            this.headerCheckbox.setChecked(newValue.includes(this.headerCheckbox.getCheckedValue()));
            this.headerCheckbox.setIndeterminate(newValue.length > 0 && newValue.length !== this.groupChildElements.length);
        }
        for (const checkbox of this.groupChildElements) {
            checkbox.setChecked(newValue.includes(checkbox.getCheckedValue()));
        }
        super.setValue(newValue, fireEvents);
    }
    clearValue(fireEvents = false) {
        super.clearValue(fireEvents);
        for (const checkbox of this.groupChildElements) {
            checkbox.clearValue(fireEvents);
        }
    }
    addCheckboxes(typedCheckbox) {
        typedCheckbox.addValueChangeHandler(event => {
            const shallowCopy = this.value.slice();
            const value = event.getValue();
            const checkedValue = typedCheckbox.getCheckedValue();
            if (value) {
                shallowCopy.push(checkedValue);
            }
            else {
                const valueIndex = shallowCopy.indexOf(checkedValue);
                shallowCopy.splice(valueIndex, 1);
            }
            if (this.headerCheckbox) {
                const allChecked = shallowCopy.length === this.groupChildElements.length;
                if (!allChecked || allChecked && this.checkHeaderIfAllChecked) {
                    this.headerCheckbox.setChecked(allChecked);
                }
                this.headerCheckbox.setIndeterminate(shallowCopy.length > 0 && shallowCopy.length !== this.groupChildElements.length);
            }
            super.setValue(shallowCopy, true);
        });
        if (typedCheckbox.isChecked()) {
            this.value.push(typedCheckbox.getValue());
        }
        if (this.headerCheckbox) {
            typedCheckbox.addCssClass("checkbox-indented");
        }
        this.groupChildElements.push(typedCheckbox);
        this.groupElement.appendChild(typedCheckbox.element);
    }
    setAllChecked(checked) {
        if (this.headerCheckbox) {
            this.headerCheckbox.setChecked(checked);
            this.headerCheckbox.setIndeterminate(false);
        }
        for (const typedCheckbox of this.groupChildElements) {
            typedCheckbox.setChecked(checked);
        }
        if (checked) {
            const checkedValues = this.groupChildElements.map(checkbox => checkbox.getCheckedValue());
            super.setValue(checkedValues, true);
        }
        else {
            super.setValue([], true);
        }
    }
    /**
     * Removes all radio buttons from the group
     */
    removeRadioButtons() {
        this.groupChildElements = [];
        while (this.groupElement.lastElementChild) {
            this.groupElement.removeChild(this.groupElement.lastElementChild);
        }
        this.clearValue();
    }
    decorateLabeledGroupElement(args) {
        this.value = []; // This needs to be set here, because the super method is still running
        const { typedCheckboxes = [], headerCheckbox, checkHeaderIfAllChecked = true } = args;
        this.checkHeaderIfAllChecked = checkHeaderIfAllChecked;
        this.headerCheckbox = headerCheckbox;
        this.element = document.createElement("div");
        this.element.classList.add("checkbox-group");
        this.groupChildElements = [];
        if (this.headerCheckbox) {
            this.groupElement.appendChild(this.headerCheckbox.element);
            this.headerCheckbox.addValueChangeHandler(event => {
                const value = event.getValue();
                for (const typedCheckbox of typedCheckboxes) {
                    typedCheckbox.setChecked(!!value);
                }
                if (value) {
                    const checkedValues = this.groupChildElements.map(checkbox => checkbox.getCheckedValue());
                    super.setValue(checkedValues, true);
                }
                else {
                    super.setValue([], true);
                }
            });
        }
        for (const typedCheckbox of typedCheckboxes) {
            this.addCheckboxes(typedCheckbox);
        }
        this.add(this.labelElement);
        this.add(this.groupElement);
    }
}
exports.default = TypedWCAGCheckboxGroup;
//# sourceMappingURL=TypedWCAGCheckboxGroup.js.map